import { Component, OnInit } from '@angular/core';
import { LoggingService } from '@app/services/logging/logging.service';

@Component({
  standalone: true,
  selector: 'app-health-check-page',
  imports: [],
  templateUrl: './health-check-page.component.html',
})
export class HealthCheckPageComponent implements OnInit {
  constructor(private readonly loggingService: LoggingService) {}

  ngOnInit(): void {
    this.loggingService.logTrace('Raven Front-End is Healthy');
  }
}
